import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Spinner,
} from "@aircall/ds";

import { ConfirmationModalProps } from "./ConfirmationModal.decl";

export function ConfirmationModal({
  title,
  description,
  show,
  actions,
  loading,
  onHide,
}: ConfirmationModalProps) {
  const [cancelAction, confirmAction] = actions;

  return (
    <AlertDialog
      open={show}
      onOpenChange={(open) => {
        if (!open) {
          onHide();
        }
      }}
    >
      <AlertDialogContent
        className="max-w-xs"
        data-test="delete-scorecard-delete-modal"
      >
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-xs font-medium text-foreground">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            variant={cancelAction.variant ?? "ghost"}
            disabled={loading}
            data-test={cancelAction["data-test"]}
            onClick={cancelAction.onClick}
          >
            {cancelAction.label}
          </AlertDialogCancel>
          <AlertDialogAction
            variant={confirmAction.variant ?? "secondary"}
            disabled={loading}
            data-test={confirmAction["data-test"] ?? "submit-button"}
            onClick={confirmAction.onClick}
          >
            {loading ? (
              <>
                <Spinner data-test="loader" />
                {confirmAction.loadingLabel ?? confirmAction.label}
              </>
            ) : (
              confirmAction.label
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
